import { useMDXComponent } from 'next-contentlayer/hooks';
import Link from 'next/link';
import getSlug from 'speakingurl';
import MdxImage from '../HelpCenter/MdxImage';
import GuideTable from './GuideTable';

const CustomLink = props => {
  const { href } = props;

  if (href.startsWith('/')) {
    return (
      <Link {...props} href={href}>
        {props.children}
      </Link>
    );
  }

  if (href.startsWith('#')) {
    return <a {...props} />;
  }

  return <a target="_blank" rel="noopener noreferrer nofollow" {...props} />;
};

// Bare elements: typography is owned by the `tf-article` rules in
// ArticleBody, which wraps this component — only anchors need ids.
// Tables become responsive comparison cards (GuideTable).
const components = {
  h2: props => <h2 id={getSlug(props.children)} {...props} />,
  h3: props => <h3 id={getSlug(props.children)} {...props} />,
  a: props => <CustomLink {...props} />,
  table: GuideTable,
};

export default function GuideMdx({ code, images }) {
  const Component = useMDXComponent(code);

  const MDXImage = props => {
    const blurDataURL =
      images && images.find(image => image.src === props.src)?.blurDataURL;
    return <MdxImage blurDataURL={blurDataURL} {...props} />;
  };

  return (
    <Component
      components={{
        ...components,
        Image: MDXImage,
      }}
    />
  );
}
